import { Pipe, PipeTransform } from '@angular/core';
import { Message } from '@app/core/models/message.model';

@Pipe({
  name: 'avatarColours'
})
export class AvatarColoursPipe implements PipeTransform {
  transform(message: Message): { 'background-color': string, 'color': string } {
    if (message.senderUserName) {
			const hue = Math.round(
				((message.senderUserName[0].toUpperCase().charCodeAt(0) - 65) / 30) * 360
			);
			return {
				'background-color': `hsl(${hue}, 85%, 85%)`,
				'color': `hsl(${hue}, 100%, 30%)`,
			};
		}
		else {
			return {
				'background-color': `hsl(0, 0%, 90%)`,
				'color': 'hsl(0, 0%, 40%)',
			};
		}
  }
}
